<div class="p-[36px] bg-neutral">
  <div class="font-termina text-[26px] mb-[14px]">Schedule Questionnaire</div>

  <div class="h-[4px] rounded-[5px] w-full bg-base-100 m-auto my-[2px]"></div>

  <div class="flex flex-col gap-4 font-montserrat my-6">
    <div class="flex items-center justify-between">
      <div class="text-[18px]">Respondent</div>
      <div class="input h-[50px] w-[500px] leading-[50px]">{{ data.respondentDetails.firstName }} {{ data.respondentDetails.lastName }}</div>
    </div>

    <div class="flex items-center justify-between">
      <div class="text-[18px]">Questionnaire</div>
      <select [(ngModel)]="questionnaireGuid" class="input h-[50px] w-[500px] leading-[50px]">
        @for (questionnaire of questionnaires; track questionnaire) {
          <option [value]="questionnaire.guid">{{ questionnaire.name }}</option>
        }
      </select>
    </div>

    <div class="flex items-center justify-between">
      <div class="text-[18px]">Dispatch Type</div>
      <select [(ngModel)]="dispatchType" (ngModelChange)="onDispatchTypeChanged()" class="input h-[50px] w-[500px] leading-[50px]">
        <option [value]="InviteLinkDispatchType.Email">Email</option>
        @if (data.respondentDetails.mobileNumber) {
          <option [value]="InviteLinkDispatchType.TextMessage">Text Message</option>
        }
      </select>
    </div>

    <div class="flex items-center justify-between">
      <div class="text-[18px]">Dispatch Date</div>
      <input [(ngModel)]="dispatchDate" type="date" class="input h-[50px] w-[500px] leading-[50px]" />
    </div>
  </div>

  <div class="h-[4px] rounded-[5px] w-full bg-base-100 m-auto my-[2px]"></div>

  <div class="font-montserrat text-[18px] my-6">
    A link to complete the <b>{{ selectedQuestionnaireName() }}</b> questionnaire will be sent by <b>{{ dispatchType | camelCaseSplit | titlecase }}</b> to <b>{{ recipient }}</b> on <b>{{ dispatchDate | date:'dd/MM/yyyy' }}</b>
  </div>

  <div class="font-montserrat text-[18px] my-6">
    Do you wish to proceed?
  </div>

  <div class="flex items-center justify-end w-full gap-4">
    <div (click)="close()" class="text-right">
      <button class="font-termina bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[14px] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none">No, go back</button>
    </div>
    <div (click)="continue()" class="text-right">
      <button class="font-termina bg-transparent border border-[var(--kek-purple)] text-[var(--kek-purple)] hover:bg-[var(--kek-purple)] hover:text-white px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[14px] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none">Yes, schedule questionnaire</button>
    </div>
  </div>
</div>